<template>
  <div>
    <!--1. 下载-->
    <div class="mb15" v-for="(item, index) in loadList" :key="index">
      <div class="flex align-items-center mb15">
        <img class="img-box-2" :src="item.icon" alt="" />
        <div class="text1">
          {{ item.title }} <span style="color: #f6350f">*</span>
        </div>
      </div>
      <div>
        <a-upload
          :file-list="item.fileList"
          :accept="item.accept"
          :remove="(file, fileList) => handleRemove(file, fileList, index)"
          :customRequest="()=>{return}"
          :before-upload="
            (file, fileList) => beforeUpload(file, fileList, index, item)
          "
        >
          <a-button
            :disabled="
              ($parent &&
                $parent.editInfo &&
                $parent.editInfo.type == 'preview') ||
              item.loading
            "
            :loading="item.loading"
          >
            <a-icon type="upload" /> 上传附件
          </a-button>
        </a-upload>
      </div>
      <div class="text2">{{ item.remarks }}</div>
    </div>
    <div class="big-box flex">
      <div class="submit-btn btn-bg-1" @click="option(1)">上 一 步</div>
      <div class="submit-btn btn-bg-2" @click="option(2)">下 一 步</div>
    </div>
  </div>
</template>

<script>
import { fileUpdate } from '@/api/index';
export default {
  name: '',
  components: {},
  props: {
    loadList: {
      type: Array,
    },
    oldApplyFiles1: {
      type: Array,
    },
  },
  data() {
    return {
      applyFiles: [],
      loading: false,
      type1: false,
      type2: false,
      type3: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  destroyed() {},
  mounted() {},
  methods: {
    handleRemove(file, fileList, fileindex) {
      this.applyFiles = this.applyFiles.filter((item) => {
        if (item.filePath.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.loadList[fileindex].fileList.indexOf(file);
      this.$emit('deleteFile', file);
      const newFileList = this.loadList[fileindex].fileList.slice();
      newFileList.splice(index, 1);
      this.loadList[fileindex].fileList = newFileList;
    },
    beforeUpload(file, fileList, fileindex, item) {
      this.$regFile(file, fileList, fileindex, item);
    },
    handleUpload(fileindex, file) {
      this.loadList[fileindex].loading = true;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('biz', 'linxuan');
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.filePath = res.message;
          fileItem.fileType = this.loadList[fileindex].id;
          fileItem.uid = file.uid;
          this.applyFiles.push(fileItem);
          this.$emit('upDataFile', fileItem, fileindex, 1);
          this.loadList[fileindex].loading = false;
          console.log(fileItem, '上传文件');
        } else {
          this.$message.error('上传失败');
        }
      });
    },
    option(type) {
      //type === 1 上一步 | type === 2 下一步
      this.loadList.map((item) => {
        let newItem = item.fileList.filter((item1) => {
          if (item.fileList.length != 0 && item1 && item1.fileType == 1) {
            this.type1 = true;
          } else if (
            item.fileList.length != 0 &&
            item1 &&
            item1.fileType == 2
          ) {
            this.type2 = true;
          } else if (
            item.fileList.length != 0 &&
            item1 &&
            item1.fileType == 3
          ) {
            this.type3 = true;
          }
        });
        return newItem;
      });

      //  下面是必填判断
      // if (this.type1 && this.type2 && this.type3) {
      if (this.oldApplyFiles1 && this.oldApplyFiles1.length > 0) {
        this.applyFiles = this.applyFiles.concat(this.oldApplyFiles1);
      }
      if (type === 1) {
        console.log(this.loadList, this.applyFiles,'step2 up')
        this.$emit('upStep', this.loadList, this.applyFiles);
      } else {
         console.log(this.loadList, this.applyFiles,'step2 next')
        this.$emit('downStep', this.loadList, this.applyFiles);
      }
      // } else {
      //   if (this.type1 === false) {
      //     this.$message.warning("请上传本校“三个一工程”工作方案");
      //   } else if (this.type2 === false) {
      //     this.$message.warning("请上传校级立项相关文件");
      //   } else {
      //     this.$message.warning("请上传专项资金经费支持相关文件");
      //   }
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb15 {
  margin-bottom: 15px;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-top: 14px;
  margin-bottom: 15px;
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  color: #fff;
  background: #9A0B00;
  line-height: 38px;
  text-align: center;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
}

.big-box {
  width: 253px;
  margin: 0 auto;
}
</style>
